import { createApi } from '@reduxjs/toolkit/query/react';

import { WorkItemFieldRequirements } from '../types/IWorkItemFieldRequirements';

import { axiosBaseQuery } from '@/redux/axios';
import { apiRoutes } from '@/api/apiRoutes';
import { GetWorkItemFieldRequirementsParams } from '@/api/types';

export const fieldRequirementsApi = createApi({
  reducerPath: 'fieldRequirementsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['WorkItemFieldRequirements'],
  endpoints: (builder) => ({
    getWorkItemFieldRequirements: builder.query<
      WorkItemFieldRequirements,
      GetWorkItemFieldRequirementsParams
    >({
      query: (params) => ({
        url: apiRoutes.getWorkItemFieldRequirements.path(params),
        method: apiRoutes.getWorkItemFieldRequirements.method,
      }),
      providesTags: ['WorkItemFieldRequirements'],
    }),
  }),
});

export const { useGetWorkItemFieldRequirementsQuery } = fieldRequirementsApi;
export default fieldRequirementsApi;
